import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import PopoverOnInteraction from '../PopoverOnInteraction';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
var PopoverOnHover = function (_a) {
    var showOnMobileClick = _a.showOnMobileClick, props = __rest(_a, ["showOnMobileClick"]);
    var isMobile = useContext(MobileContext);
    return (React.createElement(PopoverOnInteraction, __assign({ listenOnHover: true, listenOnClicks: isMobile && showOnMobileClick }, props)));
};
PopoverOnHover.displayName = 'PopoverOnHoverV2';
export default PopoverOnHover;
//# sourceMappingURL=PopoverOnHover.js.map